<template>
  <div class="as-line-ups">
    <div class="as-back-green">
      <div class="as-ground-box">
        <div class="as-mid-circle">
          <div class="as-mid-inner"></div>
        </div>
        <div v-for="(team, key) in ['home', 'away']" :key="key" class="as-w-100 as-half-box" :class="{
          'as-half-box-away': team === 'away',
        }">
          <div class="as-square2">
            <div class="as-square1"></div>
          </div>
          <div class="as-w-100">
            <div class="as-circle"></div>
          </div>
          <div class="as-lineup-players">
          </div>
        </div>
      </div>
    </div>
    <div class="as-note">
      <div v-for="(incident, key) in listIncidents" :key="key" class="as-note-item">
        <component :is="incident.icon" />{{ incident.label }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import type {
  IIncidentStatistic,
} from "~src/interfaces";
import MatchEnum from "~src/enums/MatchEnum";

interface IProps { }

withDefaults(defineProps<IProps>(), {});

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;
</script>

<script lang="ts">
export default {};
</script>
